import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});

api.interceptors.request.use(async config => {
  const token = localStorage.getItem('auth');
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

export const googleApi = axios.create({
  baseURL: `https://maps.googleapis.com/maps`,
});

export default api;
